module.exports = __webpack_public_path__ + "static/mailgun-api-key-82a822b89ec071fdb53bd7f463e17c3f.png";